// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__154T4","label":"Completed_label__1VmWe"};